<template>
  <AppSection class="relative pt-0">
    <AppContainer>
      <AppHeaderWithImg 
        :text="$tt('page.testimonials.title')"
        src="/images/megaphone-illustration.jpg"
        :alt="$tt('page.testimonials.megaphone_img')"
        class="header"
        row
      />
    </AppContainer>
    <TestimonialsCarousel :testimonials class="slider" />
  </AppSection>
</template>

<script setup lang="ts">
import type { Testimonial } from "~/types";
defineProps<{
  testimonials: Testimonial[];
}>();
</script>

<style scoped>
.header :deep(img) {
  margin-inline-start: calc(-1 * var(--space-3));
  transform: scaleX(-1) rotate(15deg);
  width: 85px !important;
  margin-bottom: var(--space-3);
}
@media (max-width: 850px) {
  :deep(.v-slide-group__container) {
    padding: var(--space-6) 0 var(--space-7) var(--space-5);
  }
}
@media (min-width: 851px) {
  .header {
    margin-bottom: calc(-1 * var(--space-6));
  }
}
</style>